import { Dropdown } from "primereact/dropdown"
import { useField } from "formik"

import { Skeleton } from "primereact/skeleton"

//Style
import styles from "../../styles/Form-Inputs.module.css"
import CustomTooltip from "../CustomTooltip"

export default function FormikDropDown({
  name,
  label,
  options,
  optionLabel,
  optionValue,
  helpText,
  placeHolderValue,
  disabled,
  showClear,
  required,
  isInitialLoad,
  onChangeCallback,
  info_id,
}) {
  const [field, meta, helpers] = useField(name)

  const getDropDown = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <Dropdown
            value={field.value}
            name={name}
            options={options}
            optionLabel={optionLabel}
            optionValue={optionValue}
            disabled={disabled}
            showClear={showClear}
            placeholder={
              !placeHolderValue ? `Please select an entry` : placeHolderValue
            }
            onChange={(e) => {
              helpers.setValue(e.value)

              if (!!onChangeCallback) {
                onChangeCallback(e.value)
              }
            }}
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            style={{ width: "100%" }}
          />
          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </>
      )
    }
  }

  const labelField = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <>
          <CustomTooltip
            label={
              helpText
                ? helpText
                : `Hover over the icon to get more information about ${label}`
            }
            position={"right"}
            targetId={info_id}
          />
          <label className={styles.label}>
            {`${label} ${required ? "*" : ""}`}
            {
              <i
                className={`pi pi-info-circle ${styles.info} ${styles.infoIcon}`}
                id={info_id}
              ></i>
            }
          </label>
        </>
      )
    }
  }

  return (
    <div className={styles.field}>
      {label && <label>{labelField()}</label>}
      <div>{getDropDown()}</div>
    </div>
  )
}
